/**
 * Registers the unified /sw.js Service Worker (app shell offline +
 * FlightSync share target + media cache).
 *
 * Also unregisters the two legacy workers (flightsync-sw.js / media-sw.js)
 * that used to fight over scope '/' and caused stale-cache white screens.
 */
export function registerAppServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', async () => {
    try {
      // Remove legacy registrations explicitly (belt and suspenders — the
      // kill-switch versions of those files also self-destruct).
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        regs
          .filter((r) => {
            const url =
              r.active?.scriptURL || r.waiting?.scriptURL || r.installing?.scriptURL || '';
            return /(flightsync-sw|media-sw)\.js$/.test(url);
          })
          .map((r) => r.unregister())
      );
      const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
      // Check for a newer SW right away (picks up deploys faster)
      reg.update().catch(() => {});
      // eslint-disable-next-line no-console
      console.info('[sw] registered, scope =', reg.scope);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('[sw] registration failed:', err?.message);
    }
  });
}
